// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Page-staticContentPageTopBgImg-vWOC8 {
  width: 100%;
  height: 100%;
  min-height: 600px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: var(--common-gray-bg);
}

.Page-staticContentPageInfoContainer-A835j {
  padding: 50px 15px 50px;
  width: 100%;
  max-width: 1260px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .Page-staticContentPageTopBgImg-vWOC8 {
    padding-top: 50%;
    min-height: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Page/Page.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,4BAA4B;EAC5B,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":[".staticContentPageTopBgImg {\n  width: 100%;\n  height: 100%;\n  min-height: 600px;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-color: var(--common-gray-bg);\n}\n\n.staticContentPageInfoContainer {\n  padding: 50px 15px 50px;\n  width: 100%;\n  max-width: 1260px;\n  margin: 0 auto;\n}\n\n@media (max-width: 768px) {\n  .staticContentPageTopBgImg {\n    padding-top: 50%;\n    min-height: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"staticContentPageTopBgImg": `Page-staticContentPageTopBgImg-vWOC8`,
	"staticContentPageInfoContainer": `Page-staticContentPageInfoContainer-A835j`
};
module.exports = ___CSS_LOADER_EXPORT___;
